/*!
 * vue-vertical-timeline v0.0.11
 * (c) JohnnyAtomsk
 * Released under the ISC License.
 */
'use strict';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'VerticalTimeline',
  props: {
    inputData: {
      type: Array,
      required: true,
      "default": function _default() {
        return [];
      }
    },
    reversed: {
      type: Boolean,
      required: true,
      "default": false
    }
  },
  computed: {
    sortedData: function sortedData() {
      var inputData = this.inputData;
      inputData.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
      if (this.reversed) inputData.reverse();
      return inputData;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.sortedData.length ? _c('div', {
    staticClass: "timeline"
  }, _vm._l(_vm.sortedData, function (item) {
    return _c('div', {
      key: item._id,
      staticClass: "timeline__item"
    }, [_c('div', {
      staticClass: "content"
    }, [item.title.length ? _c('h2', {
      staticClass: "content__heading"
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]) : _vm._e(), _vm._v(" "), item.text.length ? _c('p', [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), item.date.length ? _c('p', {
      staticClass: "content__date"
    }, [_vm._v("\n        " + _vm._s(item.date) + "\n      ")]) : _vm._e(), _vm._v(" "), item.tags.length ? _c('div', _vm._l(item.tags, function (tag) {
      return _c('span', {
        key: tag,
        staticClass: "content__tag"
      }, [_vm._v("\n          " + _vm._s(tag) + "\n        ")]);
    }), 0) : _vm._e()])]);
  }), 0) : _vm._e();
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-7fb0cec6_0", {
    source: ".timeline[data-v-7fb0cec6]{position:relative;max-width:1200px;margin:0 auto}.timeline *[data-v-7fb0cec6]{box-sizing:border-box}.timeline[data-v-7fb0cec6]::after{content:\"\";position:absolute;width:6px;background-color:#0b5184;top:0;bottom:0;left:90%;margin-left:-3px}@media screen and (min-width:1024px){.timeline[data-v-7fb0cec6]::after{left:50%}}.timeline__item[data-v-7fb0cec6]{padding:10px 40px;position:relative;background-color:inherit;width:90%}@media screen and (min-width:1024px){.timeline__item[data-v-7fb0cec6]{width:50%}}.timeline__item[data-v-7fb0cec6]::after{content:\"\";position:absolute;width:25px;height:25px;right:-19px;background-color:#fff;border:6px solid #0b5184;top:calc(50% - 16px);border-radius:50%;z-index:1}@media screen and (min-width){.timeline__item[data-v-7fb0cec6]::after{top:calc(50% - 16px)}}.timeline__item[data-v-7fb0cec6]:nth-child(odd){left:0}@media screen and (min-width:520px){.timeline__item[data-v-7fb0cec6]:nth-child(odd)::before{content:\"\";position:absolute;top:50%;right:0;width:50%;z-index:-1;height:6px;background-color:#0b5184}}@media screen and (min-width:520px){.timeline__item:nth-child(odd) .content[data-v-7fb0cec6]{padding:20px 50px 20px 30px;margin-right:60px}.timeline__item:nth-child(odd) .content[data-v-7fb0cec6]::before{content:\"\";position:absolute;height:15px;width:15px;top:50%;right:-5px;background-color:#0b5184;border:6px solid #0b5184;top:calc(50% - 10px);border-radius:50%;z-index:1}}@media screen and (min-width:520px){.timeline__item[data-v-7fb0cec6]:nth-child(even)::before{content:\"\";position:absolute;top:50%;right:0;width:50%;z-index:-1;height:6px;background-color:#0b5184}}@media screen and (min-width:520px) and (min-width:1024px){.timeline__item[data-v-7fb0cec6]:nth-child(even)::before{left:0}}@media screen and (min-width:1024px){.timeline__item[data-v-7fb0cec6]:nth-child(even){left:50%}}@media screen and (min-width:520px){.timeline__item:nth-child(even) .content[data-v-7fb0cec6]{padding:20px 50px 20px 30px;margin:0 60px 0 0}.timeline__item:nth-child(even) .content[data-v-7fb0cec6]::before{content:\"\";position:absolute;height:15px;width:15px;top:50%;right:-5px;background-color:#0b5184;border:6px solid #0b5184;top:calc(50% - 10px);border-radius:50%;z-index:1}}@media screen and (min-width:520px) and (min-width:1024px){.timeline__item:nth-child(even) .content[data-v-7fb0cec6]::before{left:-5px}}@media screen and (min-width:1024px){.timeline__item:nth-child(even) .content[data-v-7fb0cec6]{padding:20px 30px 20px 50px;margin:0 0 0 60px}}@media screen and (min-width:1024px){.timeline__item[data-v-7fb0cec6]:nth-child(even)::after{left:-18px}}.timeline .content[data-v-7fb0cec6]{background-color:#fff;position:relative}.timeline .content__heading[data-v-7fb0cec6]{color:#0b5184}.timeline .content__date[data-v-7fb0cec6]{font-style:italic}.timeline .content__tag[data-v-7fb0cec6]{padding:5px 10px;margin-right:5px;background-color:#0b5184;font-size:10px;color:#fff;border-radius:5px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = "data-v-7fb0cec6";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var VerticalTimeline = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var VerticalTimelinePlugin = {
  install: function install(Vue, options) {
    Vue.component('vertical-timeline', VerticalTimeline);
  }
};

module.exports = VerticalTimelinePlugin;
